<template>
  <div class="card-wrapper" v-if="checkPermission(['chartView'])">
    <div class="card-header">
      <div>
        <p class="card-title">Thống kê tổng quan</p>
        <p class="card-subtitle">Số liệu trong ngày</p>
      </div>
    </div>

    <div class="card-content" v-if="isLoading">
      <div class="loading-text">Đang tải dữ liệu...</div>
    </div>

    <div class="card-content" v-else>
      <el-row
          :gutter="16"
          class="stats-row"
          v-if="checkPermission(['chartView_student_information_in_school'])"
      >
        <el-col :span="6">
          <div class="summary-card tone-1">
            <p class="summary-title">Học sinh</p>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Tổng số</span><b>{{ statisticalData.kidsTotal.total }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Đang học</span><b>{{ statisticalData.kidsTotal.study }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Bảo lưu</span><b>{{ statisticalData.kidsTotal.reserve }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Chờ học</span><b>{{ statisticalData.kidsTotal.wait }}</b></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-card tone-2">
            <p class="summary-title">Điểm danh</p>
            <div class="summary-line"><i class="el-icon-document-checked"></i><span>Đã điểm danh</span><b>{{ statisticalData.attendanceTotal.attendaceYes }}</b></div>
            <div class="summary-line"><i class="el-icon-document-delete"></i><span>Chưa điểm danh</span><b>{{ statisticalData.attendanceTotal.attendaceNo }}</b></div>
            <div class="summary-line"><i class="el-icon-tableware"></i><span>Đã điểm danh ăn</span><b>{{ statisticalData.attendanceTotal.attendanceEatYes }}</b></div>
            <div class="summary-line"><i class="el-icon-tableware"></i><span>Chưa điểm danh ăn</span><b>{{ statisticalData.attendanceTotal.attendanceEatNo }}</b></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-card tone-3">
            <p class="summary-title">Đón trả</p>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Đi học</span><b>{{ statisticalData.leaveTotal.goSchool }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Đã về</span><b>{{ statisticalData.leaveTotal.leaveYes }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Chưa về</span><b>{{ statisticalData.leaveTotal.leaveNo }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Đón muộn</span><b>{{ statisticalData.leaveTotal.pickupLater }}</b></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="summary-card tone-4">
            <p class="summary-title">Khác</p>
            <div class="summary-line"><i class="el-icon-chat-line-square"></i><span>Lời nhắn</span><b>{{ statisticalData.otherTotal.message }}</b></div>
            <div class="summary-line"><i class="el-icon-edit-outline"></i><span>Dặn thuốc</span><b>{{ statisticalData.otherTotal.medicine }}</b></div>
            <div class="summary-line"><i class="el-icon-user-solid"></i><span>Nghỉ học</span><b>{{ statisticalData.otherTotal.absent }}</b></div>
            <div class="summary-line"><i class="el-icon-document-remove"></i><span>Đơn chưa duyệt</span><b>{{ statisticalData.otherTotal.absentLetterNoConfirm }}</b></div>
          </div>
        </el-col>
      </el-row>

      <div class="future-section" v-if="checkPermission(['chartView_plan_go_to_school'])">
        <p class="future-title">Dự kiến đi học</p>
        <el-row :gutter="16" v-if="safeLearnFutureList.length">
          <el-col :span="6" v-for="(item, index) in safeLearnFutureList" :key="index">
            <div class="future-card" :class="`future-card--${index + 1}`">
              <div class="future-label">
                <i class="el-icon-date"></i>
                {{ item.text }} - {{ item.date | formatDayMonth }}
              </div>
              <div class="future-number">{{ item.number }}</div>
            </div>
          </el-col>
        </el-row>
        <div class="chart-empty" v-else>Chưa có dữ liệu dự kiến đi học</div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import checkPermission from "@/utils/permission";

export default {
  name: "AttendanceStatistics",
  data() {
    return {
      statisticalData: {
        kidsTotal: {total: 0, study: 0, reserve: 0, wait: 0},
        attendanceTotal: {attendaceYes: 0, attendaceNo: 0, attendanceEatYes: 0, attendanceEatNo: 0},
        leaveTotal: {goSchool: 0, leaveYes: 0, leaveNo: 0, pickupLater: 0},
        otherTotal: {message: 0, medicine: 0, absent: 0, absentLetterNoConfirm: 0},
      },
      learnFutureList: [],
      isLoading: false,
    }
  },
  computed: {
    safeLearnFutureList() {
      return this.learnFutureList.slice(0, 4);
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    checkPermission,
    async fetchData() {
      this.isLoading = true;
      await Promise.allSettled([
        this.getDataInitialInSchool(),
        this.getLearnFutureMethod(),
      ]);
      this.isLoading = false;
    },
    async getDataInitialInSchool() {
      try {
        const resp = await DashboardService.getStatisticalInSchoolV2();
        this.statisticalData = resp.data.data || this.statisticalData;
      } catch (err) {
        console.log(err);
      }
    },
    async getLearnFutureMethod() {
      try {
        const resp = await DashboardService.getLearnFutureService();
        this.learnFutureList = Array.isArray(resp.data.data) ? resp.data.data : [];
      } catch (err) {
        console.log(err);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.card-wrapper {
  background: #f8faff;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  padding: 18px;
  margin: 20px 0;
  transition: all 0.25s ease;
}

.card-wrapper:hover {
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.2px;
}

.card-subtitle {
  margin: 4px 0 0;
  font-size: 14px;
  color: #64748b;
}

.card-content {
  min-height: 130px;
}

.loading-text,
.chart-empty {
  color: #64748b;
  font-size: 13px;
  text-align: center;
  background: rgba(241, 245, 249, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 10px;
  padding: 12px;
}

.stats-row {
  margin-bottom: 12px;
}

.summary-card {
  border-radius: 16px;
  padding: 14px;
  min-height: 160px;
  border: none;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.15);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);
}

.summary-title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.summary-line {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.35);
  padding: 7px 10px;
  font-size: 13px;
  line-height: 1.35;
  color: #ffffff;
  margin-bottom: 6px;
  transition: background 0.2s ease;
}

.summary-line:hover {
  background: rgba(255, 255, 255, 0.32);
}

.summary-line i {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}

.summary-line span {
  flex: 1;
  font-weight: 500;
}

.summary-line b {
  margin-left: auto;
  color: #ffffff;
  font-weight: 800;
  font-size: 15px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* Học sinh - tím */
.tone-1 {
  background: #7c3aed;
}

/* Điểm danh - xanh dương */
.tone-2 {
  background: #0284c7;
}

/* Đón trả - xanh lá */
.tone-3 {
  background: #059669;
}

/* Khác - hồng đỏ */
.tone-4 {
  background: #db2777;
}

.future-section {
  margin-top: 6px;
}

.future-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.future-card {
  border-radius: 14px;
  border: none;
  padding: 12px 14px;
  min-height: 76px;
  transition: all 0.2s ease;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.15);
}

.future-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.2);
}

.future-card--1 {
  background: #7c3aed;
}

.future-card--2 {
  background: #0ea5e9;
}

.future-card--3 {
  background: #d97706;
}

.future-card--4 {
  background: #e11d48;
}

.future-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.future-number {
  margin-top: 8px;
  font-size: 30px;
  line-height: 1;
  font-weight: 800;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

@media (max-width: 1200px) {
  .summary-line {
    font-size: 12px;
  }

  .future-number {
    font-size: 24px;
  }
}
</style>
